import { createReducer, on } from '@ngrx/store';
import {
  loadIsForeignUserInfo,
  loadIsForeignUserInfoUserInfoFailure,
  loadIsForeignUserInfoUserInfoSuccess,
  loadUserInfo,
  loadUserInfoFailure,
  loadUserInfoSuccess
} from '../actions/userinfo.action';

export interface UserInfoState {
  userInfo: any; //UserInfo
  loading: boolean;
  error: string | null;
}

export interface IsForeignUserInfoState {
  isForeignUser: boolean;
  loading: boolean;
  error: string | null;
}

export const userInfoInitialState: UserInfoState = {
  userInfo: null,
  loading: false,
  error: null
};

export const isForeignUserInfoInitialState: IsForeignUserInfoState = {
  isForeignUser: false,
  loading: false,
  error: null
};

export const userInfoReducer = createReducer(
  userInfoInitialState,
  on(loadUserInfo, (state) => ({ ...state, loading: true })),
  on(loadUserInfoSuccess, (state, { userInfo }) => ({
    ...state,
    loading: false,
    userInfo,
    error: null
  })),
  on(loadUserInfoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export const isForeignUserInfoReducer = createReducer(
  isForeignUserInfoInitialState,
  on(loadIsForeignUserInfo, (state) => ({ ...state, loading: true })),
  on(loadIsForeignUserInfoUserInfoSuccess, (state, { isForeignUser }) => ({
    ...state,
    loading: false,
    isForeignUser,
    error: null
  })),
  on(loadIsForeignUserInfoUserInfoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
